// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@conklin/XDL/Utilities";
import { breadcrumbStyles } from "@insite/content-library/Widgets/Basic/Breadcrumbs";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

breadcrumbStyles.pageBreadcrumbs = {
    breadcrumbs: {
        css: css`
            padding: 0 0 16px;
            flex-wrap: wrap;

            ${IconWrapper} {
                margin: 0 8px;
                flex: 0 0 6px;
                &,
                svg {
                    height: auto;
                    width: 6px;
                    color: ${color("common.ui6")};
                }
            }
        `,
    },
};
